import { usePWA } from '../../hooks/usePWA';

export function PWAUpdatePrompt() {
  const {
    needRefresh,
    offlineReady,
    updateServiceWorker,
    closeRefreshPrompt,
    closeOfflineReady,
  } = usePWA();

  return (
    <>
      {offlineReady && (
        <div
          className="fixed left-4 right-4 z-40 bg-emerald-600 text-white rounded-lg shadow-lg px-4 py-3 text-sm flex items-start gap-3"
          style={{ bottom: 'calc(5.5rem + env(safe-area-inset-bottom))' }}
        >
          <span className="text-lg">✓</span>
          <div className="flex-1">
            <p className="font-semibold">App lista para usar offline</p>
            <p className="text-white/80 text-xs mt-0.5">
              Ya puedes abrir GranArqui sin conexión.
            </p>
          </div>
          <button
            onClick={closeOfflineReady}
            className="text-white/70 hover:text-white"
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>
      )}

      {needRefresh && (
        <div
          className="fixed left-4 right-4 z-40 bg-slate-900 text-white rounded-lg shadow-2xl px-4 py-3 text-sm flex items-start gap-3"
          style={{ bottom: 'calc(5.5rem + env(safe-area-inset-bottom))' }}
        >
          <span className="text-lg">🔄</span>
          <div className="flex-1">
            <p className="font-semibold">Nueva versión disponible</p>
            <p className="text-white/80 text-xs mt-0.5">
              Actualiza para obtener las últimas mejoras.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => updateServiceWorker()}
              className="px-3 py-1.5 rounded-md bg-primary text-white text-xs font-semibold"
            >
              Actualizar
            </button>
            <button
              onClick={closeRefreshPrompt}
              className="text-white/60 hover:text-white"
              aria-label="Cerrar"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
}